module.exports = __webpack_public_path__ + "img/icon_close.dcb85a58.png";